module.exports = __webpack_public_path__ + "static/media/img_mobile_premiem_02.866cf2fe.png";